import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateBusinessRequest } from "@norma-bi/bi-api";
import { useRootAPI } from "@/api";

export function useUpdateBusiness() {
  const rootAPI = useRootAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: { businessId: string; changeset: UpdateBusinessRequest }) => {
      return rootAPI.patchBusinessesBusinessId({
        business_id: args.businessId,
        UpdateBusinessRequest: args.changeset,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["businesses"] });
    },
  });
}
